import React, { useEffect, useState } from 'react'

// Background for the home hero: destination photos that slowly zoom and
// cross-fade. The zoom is a CSS transform, so it stays smooth (no jitter).
const SLIDES = [
  { image: 'assets/img/goa.jpg', place: 'Goa, India', origin: '60% 40%' },
  { image: 'assets/img/kerela.jpg', place: 'Kerala, India', origin: '40% 50%' },
  { image: 'assets/img/andaman.jpg', place: 'Andaman Islands', origin: '50% 60%' },
  { image: 'assets/img/rajasthan.jpg', place: 'Rajasthan, India', origin: '30% 40%' },
  { image: 'assets/img/manali.jpg', place: 'Manali, Himachal', origin: '50% 30%' },
  { image: 'assets/img/agra.jpg', place: 'Agra, India', origin: '50% 50%' },
  { image: 'assets/img/darjeeling.jpg', place: 'Darjeeling, India', origin: '70% 50%' }
]

const SLIDE_MS = 6000

const HeroScene = () => {
  const [active, setActive] = useState(0)

  useEffect(() => {
    const id = setInterval(() => setActive(i => (i + 1) % SLIDES.length), SLIDE_MS)
    return () => clearInterval(id)
  }, [])

  const leaving = (active - 1 + SLIDES.length) % SLIDES.length

  return (
    <div className="hero-scene" aria-hidden="true">
      {SLIDES.map((slide, i) => (
        <div
          key={slide.image}
          className={`hs-slide${i === active ? ' is-active' : ''}${i === leaving ? ' is-leaving' : ''}`}
          style={{ backgroundImage: `url(${slide.image})`, transformOrigin: slide.origin }}
        />
      ))}
      <div className="hs-caption">
        <i className="fa fa-map-marker-alt me-2" />
        <span key={active} className="hs-caption-text">{SLIDES[active].place}</span>
      </div>
    </div>
  )
}

export default HeroScene
